import {
  APPS_ACCESS_TOKEN_PROVIDED,
  APPS_REGISTER_CALLBACKS,
} from '../../../constants/actionConstants';
import {
  paymentPactSuccess,
  paymentPactError,
} from '../payment/pactPaymentActions';
import {
  applePayEligibleOnDevice,
  applePayPaymentSuccess,
  applePayPaymentCancel,
  applePayPaymentFailure,
  getOrderData,
  getOrderDataIOS,
} from './applePayAppsActions';
import {
  googlePayEligibleOnDevice,
  onGooglePayPaymentSuccess,
  onGooglePayPaymentFailure,
  onGooglePayPaymentCancel,
} from './googlePayAppsActions';

export const registerAppsCallbacks = callbacks => ({
  type: APPS_REGISTER_CALLBACKS,
  callbacks,
});

export const accessTokenProvided = token => ({
  type: APPS_ACCESS_TOKEN_PROVIDED,
  token,
});

const registerCallbacks = store => async (callbacks) => {
  store.dispatch(registerAppsCallbacks(callbacks));
};

const setAccessToken = store => async (token) => {
  store.dispatch(accessTokenProvided(token));
};

// PACT PAYMENTS
export const pactPaymentSuccess = store => (paymentData, receipt) => {
  store.dispatch(paymentPactSuccess(paymentData, receipt));
};
export const pactPaymentError = store => (error, receipt) => {
  store.dispatch(paymentPactError(error, receipt));
};

export default store => ({
  getOrderData: getOrderData(store),
  registerCallbacks: registerCallbacks(store),
  setAccessToken: setAccessToken(store),
  getOrderDataIOS: getOrderDataIOS(store),
  pactPaymentSuccess: pactPaymentSuccess(store),
  pactPaymentError: pactPaymentError(store),
  setCanMakeApplePayPayments: applePayEligibleOnDevice(store),
  applePayPaymentSuccess: applePayPaymentSuccess(store),
  applePayPaymentCancel: applePayPaymentCancel(store),
  applePayPaymentFailure: applePayPaymentFailure(store),
  setCanMakeGooglePayPayments: googlePayEligibleOnDevice(store),
  googlePayPaymentSuccess: onGooglePayPaymentSuccess(store),
  googlePayPaymentFailure: onGooglePayPaymentFailure(store),
  googlePayPaymentCancel: onGooglePayPaymentCancel(store),
});
